export const hasReachedMaxQty = (variantId: number | string | undefined, addedQty: number = 1): boolean => {
  if (!variantId) return false;
  const variantDetails = window.Jbhifi.cartQuantities?.[variantId];
  if (!variantDetails) return false;
  return variantDetails.quantity + addedQty > variantDetails.maxQty;
};
